import React, { useRef, useState } from 'react';
import swal from 'sweetalert';
import { getVanCCavenuePaymentGateway } from '../../actions/VanSubscription';

const VanCCAvenue = ({ paymentConfig, userDetail, subsFeeDetail }) => {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [encRequest, setEncRequest] = useState('');
  const [formActionUrl, setFormActionUrl] = useState('');
  const {
    name,
    id,
    email,
    address1,
    city,
    city_id,
    other_city,
    zip_code,
    mobile_no,
  } = userDetail || {};

  const addressFormat =
    address1 !== null && address1 !== undefined
      ? String(address1).replace(/[&/\\#+()!@$~%.`'":*?^<>{}]/g, '')
      : '';
  const cityFormat =
    city_id !== null && city_id === 0
      ? other_city !== null && other_city !== undefined
        ? String(other_city).replace(/[&/\\#+()!@$~%.`'":*?^<>{}]/g, '')
        : ''
      : city;

  const checkout = async () => {
    setLoading(true);
    const data = {
      student_id: id,
      amount: parseFloat(subsFeeDetail?.amount || 0).toFixed(2),
      gateway_id: paymentConfig?.id,
      merchant_id: paymentConfig?.merchant_id,
      id: subsFeeDetail?.id,
      fee_type: subsFeeDetail?.pay_type,
      subscription_type: subsFeeDetail?.subscription_type,
      subscriptions_id: subsFeeDetail?.subscriptions_id,
      language: 'EN',
      billing_address: addressFormat,
      billing_city: cityFormat,
      billing_state: 'MH',
      billing_zip: 'zip_code',
      billing_country: 'India',
      billing_tel: mobile_no,
      billing_name: name,
      delivery_name: name,
      delivery_address: addressFormat,
      delivery_city: cityFormat,
      delivery_state: cityFormat,
      delivery_zip: zip_code,
      delivery_country: 'India',
      delivery_tel: mobile_no,
      billing_email: email,
      success_url: `${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/success`,
      failure_url: `${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/failure`,
    };

    try {
      const res = await getVanCCavenuePaymentGateway(data);
      const encryptedData = res?.encrypted_data || res?.encRequest;
      const redirectUrl = res?.ccavenue_url || res?.payment_url;

      if (res?.status && encryptedData && redirectUrl) {
        setEncRequest(encryptedData);
        setFormActionUrl(redirectUrl);
        setTimeout(() => {
          formRef.current?.submit();
        }, 300);
      } else {
        swal(res?.message || "Payment Failed! We couldn't process your payment. Please Try Again!", '', 'error');
        setLoading(false);
      }
    } catch (error) {
      swal('Something went wrong', '', 'error');
      console.log('ccavenue van subscription error...', error);
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? (
        <button type="submit" disabled className="banktransfer_btn">
          <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
          Processing ...
        </button>
      ) : (
        <button onClick={checkout} className="banktransfer_btn">
          CCAvenue
        </button>
      )}

      <form
        ref={formRef}
        id="van-ccavenue-nonseamless"
        method="POST"
        name="redirect"
        action={formActionUrl || ''}
      >
        <input type="hidden" id="encRequest" name="encRequest" value={encRequest} />
        <input
          type="hidden"
          name="access_code"
          id="access_code"
          value={paymentConfig?.access_code || ''}
        />
      </form>
    </div>
  );
};

export default VanCCAvenue;